import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { IgButton } from "@intelligems/ig-theme/IgButton";
import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { GraphConfig } from "@intelligems/ig-types/schemas/analytics/custom-graphs";
import { officialCategoryName } from "@intelligems/ig-utils/common";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";
import { BaseGraphPaper } from "@src/features/analytics/baseDashboard/chartComponents/GraphPapers";
import { HeaderDetails } from "@src/features/analytics/baseDashboard/chartComponents/HeaderDetails";
import { useReadOnlyMode } from "@src/features/publicShareLinks/hooks/useReadOnlyMode";
import { SETTINGS_ROUTES } from "@src/routes/routes";
import { selectedExperience } from "@src/store/slices/experiences";
import { SettingsSectionId } from "@src/types/navigation";

interface NoCogsGraphPlaceholderProps {
  config: GraphConfig;
}

export const NoCogsGraphPlaceholder = ({
  config,
}: NoCogsGraphPlaceholderProps) => {
  const navigate = useNavigate();
  const experience = useSelector(selectedExperience);
  const theme = useTheme();
  const { isReadOnly } = useReadOnlyMode();

  // Handle case where experience might not be loaded yet
  if (!experience) {
    return (
      <BaseGraphPaper
        sx={{
          height: "100%",
          boxSizing: "border-box",
        }}
      >
        <Grid container alignItems={"flex-start"} spacing={6}>
          <Grid>
            <HeaderDetails config={config} />
          </Grid>
        </Grid>
      </BaseGraphPaper>
    );
  }

  return (
    <BaseGraphPaper
      sx={{
        height: "100%",
        boxSizing: "border-box",
      }}
    >
      <Grid container alignItems={"flex-start"} spacing={6}>
        <Grid>
          <HeaderDetails config={config} />
        </Grid>
        <Grid>
          <IgTypography color={theme.palette.text.secondary}>
            To view profit metrics please enter COGS for more of the revenue
            generating products in this{" "}
            {officialCategoryName(experience.category, false)}.
          </IgTypography>
        </Grid>
        {!isReadOnly && (
          <Grid>
            <IgButton
              variant={"outlined"}
              onClick={() => {
                void navigate(
                  `${SETTINGS_ROUTES.Settings}#${SettingsSectionId.Cogs}`
                );
              }}
            >
              PROVIDE COGS
            </IgButton>
          </Grid>
        )}
      </Grid>
    </BaseGraphPaper>
  );
};
